import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { localizeReducer } from 'react-localize-redux'
import { reducer as formReducer } from 'redux-form'

import entities from './entities'
import user from './user'
import modal from './modal'
import snackbar from './snackbar'
import loader from './loader'

export const makeRootReducer = (asyncReducers = {}) => {
  const appReducer = combineReducers({
    // add app reducers here
    entities,
    user,
    modal,
    snackbar,
    loader,

    // 3th party
    routing: routerReducer,
    form: formReducer,
    localize: localizeReducer,

    ...asyncReducers
  })

  return (state, action) => {
    return appReducer(state, action)
  }
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) {
    return
  }

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
